import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=f2f4cfb6&scoped=true&"
import script from "./Insurance.vue?vue&type=script&lang=js&"
export * from "./Insurance.vue?vue&type=script&lang=js&"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=f2f4cfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f4cfb6",
  null
  
)

export default component.exports